import store from "@frameworks/web/redux/store/index";
import { DELETEPROFILEPIC, DELETEPROFILEPIC_ERROR, DELETEPROFILEPIC_HIDE_ERROR, DELETEPROFILEPIC_START_LOADER, DELETEPROFILEPIC_STOP_LOADER } from "../interface/IDeleteProfilePic";
class DeleteProfilePicActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    deleteProfilePicData(data) {
        this.dispatch({
            type: DELETEPROFILEPIC,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: DELETEPROFILEPIC_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: DELETEPROFILEPIC_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: DELETEPROFILEPIC_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: DELETEPROFILEPIC_STOP_LOADER,
        });
    }
}
export default DeleteProfilePicActions;
